export default "__VITE_ASSET__C0TgbxM1__"